import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductAssinaturaComponent } from './product-assinatura.component';



@NgModule({
  declarations:[
    ProductAssinaturaComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ProductAssinaturaComponent
  ]
})
export class ProductAssinaturaModule { }
